// Stable keys are shared with the API allowlists; never include route or user data.
export const gridPreferenceRegistry = {
  "portal-platform-emails-v1": { key: "portal.platform.emails.v1", kind: "platform" },
  "portal-platform-sms-v1": { key: "portal.platform.sms.v1", kind: "platform" },
  "portal-platform-invitations-v1": { key: "portal.platform.invitations.v1", kind: "platform" },
  "portal-platform-login-usage-v1": { key: "portal.platform.login-usage.v1", kind: "platform" },
  "portal-platform-notifications-v1": { key: "portal.platform.notifications.v1", kind: "platform" },
  "portal-platform-guides-v1": { key: "portal.platform.guides.v1", kind: "platform" },
  "account-customer-orders-v1": { key: "portal.account.orders.v1", kind: "agency" },
  "account-customer-order-items-v1": { key: "portal.account.order-items.v1", kind: "agency" },
  "agency-members": { key: "portal.account.members.v1", kind: "agency" },
  "portal-platform-companies-v1": { key: "portal.platform.companies.v1", kind: "platform" },
  "portal-platform-domains-v1": { key: "portal.platform.domains.v1", kind: "platform" },
  "portal-platform-connections-v1": { key: "portal.platform.connections.v1", kind: "platform" },
  "portal-platform-keys-v1": { key: "portal.platform.keys.v1", kind: "platform" },
  "portal-platform-administrators-v1": { key: "portal.platform.administrators.v1", kind: "platform" },
};
